"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Input = _interopRequireDefault(require("../form-elements/Input"));
var _CustomDataList = _interopRequireDefault(require("../form-elements/CustomDataList"));
var _ActionButton = _interopRequireDefault(require("../buttons/ActionButton"));
var _ResultsTable = _interopRequireDefault(require("../tables/ResultsTable"));
var _AdBlock = _interopRequireDefault(require("../block/AdBlock"));
var _FakeDataResource = require("../../data-resources/FakeDataResource");
var _events = require("../../utils/events.js");
var _helpers = require("../../utils/helpers");
var _ChannelSearchModule = _interopRequireDefault(require("../../scss/layouts/ChannelSearch.module.scss"));
function ChannelSearch({
  network,
  baseApiUrl,
  authApiUrl,
  ct,
  allowZipcodeSearch = true,
  allowStateSearch = true,
  compactLayout = false,
  allowAutoScroll = true,
  autoScrollOffset = 25,
  ad = {
    campaign: '',
    source: '',
    medium: '',
    content: ''
  }
}) {
  const stateSearched = (0, _react.useRef)('');
  const getSearchResults = async (searchCriteria = {
    type: '',
    term: ''
  }) => {
    const fetchData = async () => {
      const endpoint = `${baseApiUrl}/${network.slug}?${searchCriteria.type}=${searchCriteria.term}`;
      try {
        const response = await fetch(endpoint);
        if (!response.ok) {
          console.error(`Response not OK from ${endpoint}`);
          return [];
        }
        const results = await response.json();
        return results.map(item => {
          return {
            city: `${item.city}, ${item.state.toUpperCase()}`,
            call_letters: item.call_letters,
            ota: item.ota,
            provider: item.cable !== null && item.cable !== "" ? item.cable : item.satellite
          };
        });
      } catch (err) {
        console.error(err);
        return [];
      }
    };

    //**  this will be used for the new layout when the updated data is ready
    // const uniqByKeepLast = (data, key) => {
    //     return [
    //         ...new Map(
    //             data.map(x => [key(x), x])
    //         ).values()
    //     ]
    // }

    if (searchCriteria.term === '') return [];
    return await fetchData();
    //** eventually will use this to get the unique OTA stations: uniqByKeepLast(await fetchData(), item => item.ota).filter(item => !Number.isNaN(Number.parseFloat(item.ota)))
  };
  const handleSubmit = async e => {
    var _formData, _formData2;
    e.preventDefault();
    const form = new FormData(document.getElementById('channel-search'));
    let formData = {};
    for (let [k, v] of form.entries()) {
      formData = {
        ...formData,
        [k]: v
      };
    }
    if (formData.zipcode && ((_formData = formData) === null || _formData === void 0 ? void 0 : _formData.zipcode) !== '') {
      setSearchResults(await getSearchResults({
        type: 'zip',
        term: formData.zipcode
      }));
      setShowResults(true);
    } else if (formData.state && ((_formData2 = formData) === null || _formData2 === void 0 ? void 0 : _formData2.state) !== '') {
      const state = _FakeDataResource.statesForCustomList.find(state => Number.parseInt(state.id, 10) === Number.parseInt(formData.state, 10));
      stateSearched.current = state.label;
      setSearchResults(await getSearchResults({
        type: 'state',
        term: state.value
      }));
      setShowResults(true);
    } else {
      setSearchResults(await getSearchResults());
      setShowResults(false);
    }
    setTimeout(() => {
      (0, _events.publish)('scripps:action:completed');
    }, 250);
  };
  const columns = [{
    title: `City`,
    resultKey: `city`
  }, {
    title: `Station`,
    resultKey: `call_letters`
  }, {
    title: `Antenna Channel`,
    resultKey: `ota`
  }, {
    title: 'Cable/Satellite',
    resultKey: `provider`
  }];
  const [searchResults, setSearchResults] = (0, _react.useState)(getSearchResults());
  const [showResults, setShowResults] = (0, _react.useState)(false);
  const resultsHeaderRef = (0, _react.useRef)();
  (0, _react.useEffect)(() => {
    if (showResults && allowAutoScroll) {
      setTimeout(() => {
        window.scroll({
          left: 0,
          top: resultsHeaderRef.current.getBoundingClientRect().y + window.pageYOffset - autoScrollOffset,
          behavior: 'smooth'
        });
      }, 100);
    }
  });
  return /*#__PURE__*/_react.default.createElement("channel-search__wrapper", null, /*#__PURE__*/_react.default.createElement("form", {
    className: (0, _helpers.classes)([_ChannelSearchModule.default['channel-search'], 'channel-search']),
    id: "channel-search"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _helpers.classes)([_ChannelSearchModule.default['channel-search__label'], 'channel-search__label'])
  }, network.brand_name, " Channel Search:"), /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _helpers.classes)([_ChannelSearchModule.default['channel-search__inputs'], 'channel-search__inputs'])
  }, allowZipcodeSearch && /*#__PURE__*/_react.default.createElement(_Input.default, {
    name: "zipcode",
    placeholder: "Enter ZIP Code",
    showValidation: false
  }), allowZipcodeSearch && allowStateSearch && `or`, allowStateSearch && /*#__PURE__*/_react.default.createElement(_CustomDataList.default, {
    name: "state",
    options: _FakeDataResource.statesForCustomList,
    placeholder: "Select Your State",
    showValidation: false
  })), /*#__PURE__*/_react.default.createElement(_ActionButton.default, {
    label: "Submit",
    type: "submit",
    onClick: handleSubmit,
    classname: (0, _helpers.classes)(['channel-search__submit-btn', _ChannelSearchModule.default['channel-search__submit-btn']])
  })), showResults && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _helpers.classes)([_ChannelSearchModule.default['results-table__header'], 'search-results-header', compactLayout ? _ChannelSearchModule.default['results-table__header--compact'] : '']),
    ref: resultsHeaderRef
  }, searchResults.length > 1 ? `${allowStateSearch && !allowZipcodeSearch ? stateSearched.current : 'Your'} ${network.brand_name} Channels` : `Your ${network.brand_name} Channel`), /*#__PURE__*/_react.default.createElement(_ResultsTable.default, {
    columns: columns,
    results: searchResults,
    noResultsMsg: `Sorry there are no channels carrying ${network.brand_name} in your area at this time.`,
    compactLayout: compactLayout
  })), !compactLayout && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _helpers.classes)([_ChannelSearchModule.default['ad-wrapper'], 'ad-wrapper'])
  }, /*#__PURE__*/_react.default.createElement(_AdBlock.default, {
    ad: {
      header: 'Your Educational Source For Free Over-The Air TV',
      description: `Get 30+ channels with the most popular shows, live sports and events for free in HD from leading TV Networks.`,
      href: `https://www.thefreetvproject.org/`,
      linkText: 'Learn More',
      campaign: ad.campaign,
      source: ad.source,
      medium: ad.medium,
      content: ad.content
    },
    image: {
      url: 'https://ewscripps.brightspotcdn.com/dims4/default/dc87184/2147483647/strip/true/crop/3439x3118+0+0/resize/300x272!/quality/90/?url=http%3A%2F%2Fewscripps-brightspot.s3.amazonaws.com%2F47%2Fbd%2F04d81c05418fa7112d770ca660f2%2Fftvp-logo.png',
      altText: 'The FreeTV Project',
      text: 'Search Provided by'
    },
    theme: "round2"
  })));
}
var _default = exports.default = ChannelSearch;